<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Tronc</h1>
    <p>Does your company operate tronc payroll, often used for distributing tips, gratuities and service charges?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasTroncSystem">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasTroncSystem">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasTroncSystem === undefined || props.formData.hasTroncSystem === null || props.formData.hasTroncSystem === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}



const executeStep = async () => {
  return true;
}





defineExpose({ validateStep, executeStep });

</script>